// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"TripList_sliderWrapper__YUeij","visuallyHidden":"TripList_visuallyHidden__3Lpyx"};